<template>
  <TemplateDemandBooking4 />
</template>

<script>
import TemplateDemandBooking4 from "@/views/Templates/Demand/TemplateDemandBooking4";
import { onMounted } from "vue";
import nativeHandlerService from "@/services/nativeHandler";

export default {
  name: "Booking4",
  components: {
    TemplateDemandBooking4,
  },
  setup() {
    onMounted(async () => {
      nativeHandlerService.demand.ncSetDemandIndex(4);
    });
  },
};
</script>
